import React from 'react';
import { Button, Card } from 'react-bootstrap';
import RevisionStatus from './RevisionStatus';

export default function OpenConceptRevisionCard({
  revision,
  isLoading,
  openRevision,
}) {
  return (
    <Card className="mb-2">
      <Card.Body>
        <div className="d-flex justify-content-between">
          <div>
            <p className="date">{revision.lastModified}</p>
            <RevisionStatus status={revision.status} className="text-white" />
          </div>
          <div className="text-end">
            <Button
              disabled={isLoading}
              onClick={openRevision}
              size="sm"
              variant="primary"
            >
              {isLoading ? 'Loading...' : 'OPEN Rev. ' + revision.revision}
            </Button>
          </div>
        </div>
        <p className="short-notes">{revision.notes}</p>
      </Card.Body>
    </Card>
  );
}
